var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3447 11.1068L14.863 7.69417H11.621V5.48058C11.621 4.54672 12.0731 3.63592 13.5251 3.63592H15V0.730583C15 0.730583 13.6621 0.5 12.3836 0.5C9.71233 0.5 7.96804 2.13483 7.96804 5.0932V7.69417H5V11.1068H7.96804V19.357C8.56393 19.4516 9.17352 19.5 9.79452 19.5C10.4155 19.5 11.0251 19.4516 11.621 19.357V11.1068H14.3447Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.383c202eb0d7eb349c44f0d8a051a37e.svg";
export { ForwardRef as ReactComponent };